(function () {
/*
  * -----------------------------------------------------------------------------
  * @elkfox/room-calculator
  * -----------------------------------------------------------------------------
  */ if (customElements.get("room-calculator") === undefined) {
    class RoomCalculator extends HTMLElement {
        constructor(){
            super();
            this.RoomCalculatorTotals = this.querySelector("calculator-excess");
            this.addEventListener("input", this.inputUpdate, false);
        }
        inputUpdate() {
            let total = 0;
            this.querySelectorAll("room-calculator-room")?.forEach((room)=>total = total += Number(room.querySelector("calculator-area-parallelogram").inputTotal.value));
            this.updateTotal(total);
        }
        updateTotal(total) {
            if (isNaN(total)) return false;
            this.RoomCalculatorTotals.inputSubtotal.value = parseFloat(total);
            this.RoomCalculatorTotals.inputSubtotal.dispatchEvent(new Event("input"));
        }
    }
    customElements.define("room-calculator", RoomCalculator);
}
/*
  * -----------------------------------------------------------------------------
  * @elkfox/room-calculator-room
  * -----------------------------------------------------------------------------
  */ if (customElements.get("room-calculator-room") === undefined) {
    class RoomCalculatorRoom extends HTMLElement {
        constructor(){
            super();
        }
    }
    customElements.define("room-calculator-room", RoomCalculatorRoom);
}
/*
  * -----------------------------------------------------------------------------
  * @elkfox/room-calculator-room-add
  * -----------------------------------------------------------------------------
  */ if (customElements.get("room-calculator-room-add") === undefined) {
    class RoomCalculatorRoomAdd extends HTMLElement {
        constructor(){
            super();
            this.RoomCalculator = document.querySelector("room-calculator");
            this.querySelector('button[name="add"]')?.addEventListener("click", this.addRoom.bind(this), false);
        }
        addRoom() {
            const newRoom = this.querySelector("template").content.firstElementChild.cloneNode(true);
            this.RoomCalculator.insertBefore(newRoom, this);
            newRoom.querySelectorAll("input")[0].focus();
            this.nameRoom(newRoom);
        }
        nameRoom(newRoom) {
            const roomName = newRoom.querySelector("content-editable-defaultable");
            const roomCount = this.RoomCalculator.querySelectorAll("room-calculator-room").length;
            const newName = roomName.innerText + " " + roomCount;
            roomName.editableContent.innerText = newName;
            roomName.defaultContent = newName;
        }
    }
    customElements.define("room-calculator-room-add", RoomCalculatorRoomAdd);
}

})();
